import { css } from 'emotion';
const styles = css`
  max-width: 600px;
  margin: 100px auto 0;
  margin-top: calc((100vh - 400px) / 2);
  min-height: 100px;
  background: white;
  border: 1px solid #ddd;
  padding: 20px;
  position: relative;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  outline: none !important;
`;

export default styles;
